import Vue from "vue"
import Router from "vue-router"

// Client
const ClientView = () => import(/*webpackChunkName: "client-view-group" */ "@/app/views/client-view/client-view.vue")
const LandingPageContainer = () =>
	import(
		/*webpackChunkName: "land-page-container" */ "@/app/views/client-view/landing-page/containers/land-page-container/land-page-container.vue"
	)
const HealthCheckContainer = () =>
	import(
		/*webpackChunkName: "health-check-container" */ "@/app/views/client-view/health-check/containers/health-check-container/health-check-container.vue"
	)
const PrivacyPolicyPageContainer = () =>
	import(
		/*webpackChunkName: "privacy-policy-container" */ "@/app/views/client-view/privacy-policy-page/containers/privacy-policy-container/privacy-policy-container.vue"
	)
const DogPurchasePublicContainer = () =>
	import(
		/*webpackChunkName: "dog-purchase-public-container" */ "@/app/views/client-view/dog-purchase-public-page/containers/dog-purchase-public/dog-purchase-public.vue"
	)
const DogPurchaseTransactionContainer = () =>
	import(
		/*webpackChunkName: "dog-purchase-transaction-container" */ "@/app/views/client-view/dog-purchase-public-page/containers/dog-purchase-transaction/dog-purchase-transaction.vue"
	)
const DogPurchaseSuccessContainer = () =>
	import(
		/*webpackChunkName: "dog-purchase-success-container" */ "@/app/views/client-view/dog-purchase-public-page/containers/dog-purchase-public-success/dog-purchase-public-success.vue"
	)
const DogPurchasePayNowContainer = () =>
	import(
		/*webpackChunkName: "dog-purchase-pay-now-container" */ "@/app/views/client-view/dog-purchase-public-page/containers/dog-purchase-public-pay-now/dog-purchase-public-pay-now.vue"
	)
const ContactUsPageContainer = () =>
	import(
		/*webpackChunkName: "contact-us-container" */ "@/app/views/client-view/contact-us-page/containers/contact-us-container/contact-us-container.vue"
	)
const PuppyForSalePageContainer = () =>
	import(
		/*webpackChunkName: "puppy-for-sale-container" */ "@/app/views/client-view/puppy-for-sale-page/containers/puppy-for-sale-container/puppy-for-sale-container.vue"
	)
const PuppyForSaleDetailsContainer = () =>
	import(
		/*webpackChunkName: "puppy-for-sale-details-container" */ "@/app/views/client-view/puppy-for-sale-page/containers/puppy-for-sale-details-container/puppy-for-sale-details-container/puppy-for-sale-details-container.vue"
	)
const PuppyPurchaseContainer = () =>
	import(
		/*webpackChunkName: "puppy-purchase" */ "@/app/views/client-view/puppy-for-sale-page/containers/puppy-purchase/puppy-purchase.vue"
	)
const PuppyPurchasePayNowContainer = () =>
	import(
		/*webpackChunkName: "puppy-purchase-pay-now-container" */ "@/app/views/client-view/puppy-for-sale-page/containers/puppy-purchase-pay-now-container/puppy-purchase-pay-now-container.vue"
	)
const DoggyPackPageListContainer = () =>
	import (
		/*webpackChunkName: "doggy-pack-list-container" */ "@/app/views/client-view/doggy-pack-page/containers/doggy-pack-list-container/doggy-pack-list-container.vue"
	)
const DoggyPacksDetailsContainer = () =>
	import(
		/*webpackChunkName: "doggy-packs-details-container" */ '@/app/views/client-view/doggy-pack-page/containers/doggy-packs-details-container/doggy-packs-details-container.vue'
	)

// Auth
const AuthContainer = () =>
	import(/*webpackChunkName: "auth-container" */ "@/app/views/auth-view/containers/auth-container/auth-container.vue")
const AuthLogin = () =>
	import(/*webpackChunkName: "auth-login" */ "@/app/views/auth-view/components/auth-login/auth-login.vue")
const AuthRegisterContainer = () =>
	import(
		/*webpackChunkName: "auth-register-container" */ "@/app/views/auth-view/components/auth-register/containers/auth-register-container/auth-register-container.vue"
	)
const AuthBreederRegisterContainer = () =>
	import(
		/*webpackChunkName: "auth-breeder-register-container" */ "@/app/views/auth-view/components/auth-breeder-register/containers/auth-breeder-register-container/auth-breeder-register-container.vue"
	)
const AuthForgotPass = () =>
	import(
		/*webpackChunkName: "auth-forgot-pass" */ "@/app/views/auth-view/components/auth-forgot-password/auth-forgot-password.vue"
	)
const AuthSetPass = () =>
	import(
		/*webpackChunkName: "auth-set-pass" */ "@/app/views/auth-view/components/auth-set-password/auth-set-password.vue"
	)

// Main
const MainView = () => import(/*webpackChunkName: "main-view" */ "@/app/views/main-view/main-view.vue")
const GeneralInfoContainer = () =>
	import(
		/*webpackChunkName: "general-info-container" */ "@/app/views/main-view/general-info/containers/general-info-container/general-info-container.vue"
	)
const DashboardContainer = () =>
	import(
		/*webpackChunkName: "dashboard-container" */ "@/app/views/main-view/dashboard/containers/dashboard-container/dashboard-container.vue"
	)
const TrackingContainer = () =>
	import(
		/*webpackChunkName: "tracking-container" */ "@/app/views/main-view/tracking/containers/tracking-container/tracking-container.vue"
	)
const HealthDataContainer = () =>
	import(
		/*webpackChunkName: "health-data-container" */ "@/app/views/main-view/health-data/containers/health-data-container/health-data-container.vue"
	)
const TreatmentContainer = () =>
	import(
		/*webpackChunkName: "treatment-container" */ "@/app/views/main-view/treatment/containers/treatment-container/treatment-container.vue"
	)
const SocialClubContainer = () =>
	import(
		/*webpackChunkName: "social-club-container" */ "@/app/views/main-view/social-club/containers/social-club-container/social-club-container.vue"
	)
const NotificationsContainer = () =>
	import(
		/*webpackChunkName: "notifications-container" */ "@/app/views/main-view/notifications/containers/notifications-container/notifications-container.vue"
	)
const SettingsContainer = () =>
	import(
		/*webpackChunkName: "settings-container" */ "@/app/views/main-view/settings/containers/settings-container/settings-container.vue"
	)
const ProfileContainer = () =>
	import(
		/*webpackChunkName: "profile-container" */ "@/app/views/main-view/profile/containers/profile-container/profile-container.vue"
	)
const ChangePassContainer = () =>
	import(
		/*webpackChunkName: "change-pass-container" */ "@/app/views/main-view/change-password/containers/change-password-container/change-password-container.vue"
	)
const PetProfileContainer = () =>
	import(
		/*webpackChunkName: "pet-profile-container"*/ "@/app/views/main-view/pet-profile/containers/pet-profile-container/pet-profile-container.vue"
	)
const SocialPostContainer = () =>
	import(
		/*webpackChunkName: "social-post-container" */ "@/app/views/main-view/social-club/containers/social-post-container/social-post-container.vue"
	)
const AppSharingContainer = () =>
	import(
		/*webpackChunkName: "app-sharing-container" */ "@/app/views/main-view/app-sharing/containers/app-sharing-container/app-sharing-container.vue"
	)
const WalkerSitterContainer = () =>
	import(
		/*webpackChunkName: "app-sharing-container" */ "@/app/views/main-view/walker-sitter/containers/walker-sitter-container/walker-sitter-container.vue"
	)
const WalkerSitterProfileContainer = () =>
	import(
		/*webpackChunkName: "walker-sitter-profile-container" */ "@/app/views/main-view/walker-sitter-profile/containers/walker-sitter-profile-container/walker-sitter-profile-container.vue"
	)
const PetExerciseContainer = () =>
	import(
		/*webpackChunkName: "pet-exercise-container" */ "@/app/views/main-view/pet-exercise/containers/pet-exercise-container/pet-exercise-container.vue"
	)

// Purchases 
const PurchasesView = () =>
	import(
		/*webpackChunkName: "purchases-view" */ "@/app/views/main-view/purchases/purchases-view.vue"
	)

const PurchasesContainer = () =>
	import(
		/*webpackChunkName: "purchases-container" */ "@/app/views/main-view/purchases/containers/purchases-container/purchases-container.vue"
	)

const ProductPurchaseListingContainer = () =>
	import(
		/*webpackChunkName: "purchases-product-listing-container" */ "@/app/views/main-view/purchases/containers/product-purchase/product-purchase-listing-container/product-purchase-listing-container.vue"
	)
	
const SubscriptionListingContainer = () =>
	import(
		/*webpackChunkName: "subscription-listing-container" */ "@/app/views/main-view/purchases/containers/subscription/subscription-listing-container/subscription-listing-container.vue"
	)
	
const PuppyPurchaseListingContainer = () =>
	import(
		/*webpackChunkName: "puppy-purchase-listing-container" */ "@/app/views/main-view/purchases/containers/puppy-purchase/puppy-purchase-listing-container/puppy-purchase-listing-container.vue"
	)

// const DogPurchaseContainer = () =>
// 	import(
// 		/*webpackChunkName: "dog-purchase-container" */ "@/app/views/main-view/dog-purchase/containers/dog-purchase-container/dog-purchase-container.vue"
// 	)
// Note: This component is no longer being used.
// const DogPurchaseCheckoutContainer = () =>
// 	import(
// 		/*webpackChunkName: "dog-purchase-checkout-container" */ "@/app/views/main-view/dog-purchase/containers/dog-purchase-checkout-container/dog-purchase-checkout-container.vue"
// 	)
const ProductPurchaseDetailsContainer = () =>
	import(
		/*webpackChunkName: "product-purchase-details-container" */ "@/app/views/main-view/purchases/containers/product-purchase/product-purchase-details-container/product-purchase-details-container.vue"
	)
const SubscriptionDetailsContainer = () =>
	import(
		/*webpackChunkName: "subscription-details-container" */ "@/app/views/main-view/purchases/containers/subscription/subscription-details-container/subscription-details-container.vue"
	)
// const DogTransactionsContainer = () =>
// 	import(
// 		/*webpackChunkName: "dog-transaction-history-container" */ "@/app/views/main-view/dog-purchase/containers/dog-transaction-history-container/dog-transaction-history-container.vue"
// 	)
// const DogPurchaseDetails = () =>
// 	import(
// 		/*webpackChunkName: "dog-purchase-details" */ "@/app/views/main-view/dog-purchase/containers/dog-request-details/dog-request-details.vue"
// 	)
const PuppyPurchaseDetails = () =>
	import(
		/*webpackChunkName: "puppy-purchase-details-container" */ "@/app/views/main-view/purchases/containers/puppy-purchase/puppy-purchase-details-container/puppy-purchase-details-container.vue"
	)

// Products
const ProductView = () =>
	import(/*webpackChunkName: "product-view" */ "@/app/views/main-view/products/products-view.vue")
const ProductContainer = () =>
	import(
		/*webpackChunkName: "product-container" */ "@/app/views/main-view/products/containers/products-container/products-container.vue"
	)
const ProductListContainer = () =>
	import(
		/*webpackChunkName: "product-list-container" */ "@/app/views/main-view/products/containers/product-list-container/product-list-container.vue"
	)
const ProductDetailsContainer = () =>
	import(
		/*webpackChunkName: "product-details-container" */ "@/app/views/main-view/products/containers/product-details-container/product-details-container.vue"
	)
const ProductCartContainer = () =>
	import(
		/*webpackChunkName: "product-cart-container" */ "@/app/views/main-view/products/containers/product-cart-container/product-cart-container.vue"
	)
const ProductCheckoutContainer = () =>
	import(
		/*webpackChunkName: "product-checkout-container" */ "@/app/views/main-view/products/containers/product-checkout-container/product-checkout-container.vue"
	)
// const ProductTransactionHistoryContainer = () =>
// 	import(
// 		/*webpackChunkName: "product-transaction-container"*/ "@/app/views/main-view/products/containers/product-transaction-history-container/product-transaction-history-container.vue"
// 	)

// transaction
const TransactionSuccess = () =>
	import(
		/*webpackChunkName: "transaction-success"*/ "@/app/views/main-view/transaction/containers/transaction-success-container/transaction-success-container.vue"
	)
const TransactionFailed = () =>
	import(
		/*webpackChunkName: "transaction-failed"*/ "@/app/views/main-view/transaction/containers/transaction-failed-container/transaction-failed-container.vue"
	)
const TransactionStatus = () =>
	import(
		/*webpackChunkName: "transaction-status"*/ "@/app/views/main-view/transaction/containers/transaction-status/transaction-status.vue"
	)

// Sell your dog
const SellYourDogView = () =>
	import(/*webpackChunkName: "sell-your-dog-group" */ "@/app/views/main-view/sell-your-dog/sell-your-dog-views.vue")
const SellYourDogContainer = () =>
	import(
		/*webpackChunkName: "sell-your-dog-container" */ "@/app/views/main-view/sell-your-dog/containers/sell-your-dog-container/sell-your-dog-container.vue"
	)
const SellYourDogInfoContainer = () =>
	import(
		/*webpackChunkName: "sell-your-dog-info-container" */ "@/app/views/main-view/sell-your-dog/containers/sell-your-dog-info-container/sell-your-dog-info-container.vue"
	)

// Breeder Bio Form
const BreederBioFormContainer = () =>
	import(
		/*webpackChunkName: "breeder-bio-form-container" */ "@/app/views/main-view/sell-your-dog/containers/breeder-bio-form-container/breeder-bio-form-container.vue"
	)

// Public View Breeder Bio
const BreederBioDetailsContainer = () =>
	import(
		/*webpackChunkName: "breeder-bio-details-container" */ "@/app/views/client-view/breeder-bio-page/containers/breeder-bio-details-container/breeder-bio-details-container.vue"
	)

// ******************************************* Breeding Management *******************************************
// Dam/Sire View
const DamSireView = () =>
	import(/*webpackChunkName: "dam-sire-view" */ "@/app/views/main-view/breeding-management/dam-sire/dam-sire-view.vue")

// Breeder Dashboard Container
// const BreederDashboardContainer = () =>
// 	import(/*webpackChunkName: "breeder-dashboard-container" */ "@/app/views/main-view/breeder-dashboard/containers/breeder-dashboard-container/breeder-dashboard-container.vue")
// DamSireListContainer
const DamSireListContainer = () =>
	import(/*webpackChunkName: "dam-sire-list-container" */ "@/app/views/main-view/breeding-management/dam-sire/containers/dam-sire-list-container/dam-sire-list-container.vue")

const MatingDashboardContainer = () =>
	import(/*webpackChunkName: "mating-list-container" */ "@/app/views/main-view/breeding-management/mating/containers/mating-list-container/mating-list-container.vue")

// Add Dam/Sire Container
const AddDamSireContainer = () =>
	import(/*webpackChunkName: "add-dam-sire-container" */ "@/app/views/main-view/breeding-management/dam-sire/containers/add-dam-sire-container/add-dam-sire-container.vue")

// Edit Dam/Sire Container
const EditDamSireContainer = () =>
	import(/*webpackChunkName: "edit-dam-sire-container" */ "@/app/views/main-view/breeding-management/dam-sire/containers/edit-dam-sire-container/edit-dam-sire-container.vue")

// Dam/Sire Documents Container
const DamSireDocumentsContainer = () =>
	import(/*webpackChunkName: "dam-sire-documents-container" */ "@/app/views/main-view/breeding-management/dam-sire/containers/dam-sire-documents-container/dam-sire-documents-container.vue")

//  ********************************* Mating View
const MatingView = () =>
	import(/*webpackChunkName: "mating-view" */ "@/app/views/main-view/breeding-management/mating/mating-view/mating-view.vue")

// Add Mating Container
const AddMatingContainer = () =>
	import(/*webpackChunkName: "add-mating-container" */ "@/app/views/main-view/breeding-management/mating/containers/add-mating-container/add-mating-container.vue")

// Edit Mating Container
const EditMatingContainer = () =>
	import(/*webpackChunkName: "edit-mating-container" */ "@/app/views/main-view/breeding-management/mating/containers/edit-mating-container/edit-mating-container.vue")

//  *********************************  Add Mating, Ovulation, Gestation and Whelping Dates 
const AddMatingOvulationGestationWhelpingContainer = () =>
	import(/*webpackChunkName: "add-mating-ovulation-gestation-whelping-container" */ "@/app/views/main-view/breeding-management/dam-sire/containers/add-mating-ovulation-gestation-whelping-container/add-mating-ovulation-gestation-whelping-container.vue")

//  *********************************  Add Mating, Ovulation, Gestation and Whelping Dates 
const EditMatingOvulationGestationWhelpingContainer = () =>
	import(/*webpackChunkName: "edit-mating-ovulation-gestation-whelping-container" */ "@/app/views/main-view/breeding-management/dam-sire/containers/edit-mating-ovulation-gestation-whelping-container/edit-mating-ovulation-gestation-whelping-container.vue")


//  ********************************* Gestation Period
// Gestation Period Container
const GestationPeriodContainer = () =>
	import(/*webpackChunkName: "gestation-period-container" */ "@/app/views/main-view/breeding-management/gestation-period/containers/gestation-period-container/gestation-period-container.vue");

//  ********************************* Add Litter
// Gestation Period Container
const AddLitterContainer = () =>
	import(/*webpackChunkName: "add-litter-container" */ "@/app/views/main-view/breeding-management/litter-management/containers/add-litter-container/add-litter-container.vue");


// ************************************************************************************************************

//  ********************************* Puppy Management View
const PuppyManagementView = () =>
	import(/*webpackChunkName: "mating-view" */ "@/app/views/main-view/breeding-management/puppy-management/puppy-management-view/puppy-management-view.vue")


//Puppy Management List
const PuppyManagementList = () =>
	import(/*webpackChunkName: "puppy-management-view" */ "@/app/views/main-view/breeding-management/puppy-management/containers/puppy-management-view/puppy-management-list-container.vue")

const LitterList = () =>
	import(/*webpackChunkName: "litter-list-view" */ "@/app/views/main-view/breeding-management/puppy-management/containers/litter-list-container/litter-list-container.vue")

const EditLitterContainer = () =>
	import(/*webpackChunkName: "edit-litter-container" */ "@/app/views/main-view/breeding-management/puppy-management/containers/edit-litter-container/edit-litter-container.vue");

const LitterReminderNotes = () =>
	import(/*webpackChunkName: "litter-reminder-notes" */ "@/app/views/main-view/breeding-management/puppy-management/containers/litter-reminder-notes/litter-reminder-notes.vue")


const LitterReminderAndNotesContainer = () =>
	import(/*webpackChunkName: "litter-reminder-and-notes" */ "@/app/views/main-view/breeding-management/puppy-management/containers/litter-reminder-and-notes-container/litter-reminder-and-notes-container.vue")


// ************************************************************************************************************

//  ********************************* Puppy Management View
const WaitlistTableContainer = () =>
	import(/*webpackChunkName: "waitlist-table-container" */ "@/app/views/main-view/breeding-management/waitlist/containers/waitlist-table-container/waitlist-table-container.vue")

const AllocatePuppyContainer = () =>
	import(/*webpackChunkName: "allocate-puppy-container" */ "@/app/views/main-view/breeding-management/waitlist/containers/allocate-puppy-container/allocate-puppy-container.vue")

const EditAllocatedPuppyContainer = () =>
	import(/*webpackChunkName: "edit-allocated-puppy-container" */ "@/app/views/main-view/breeding-management/waitlist/containers/edit-allocated-puppy-container/edit-allocated-puppy-container.vue")

// ************************************************************************************************************

// Public Products
const PublicProductsContainer = () =>
	import(
		/*webpackChunkName: "public-products-container" */ "@/app/views/client-view/public-products-page/containers/public-products-container/public-products-container.vue"
	)

const PublicCartContainer = () =>
	import(
		/*webpackChunkName: "public-cart-container" */ "@/app/views/client-view/public-products-page/containers/public-cart-container/public-cart-container.vue"
	)

// Account Activation
const ActivationEmailPage = () =>
	import(
		/*webpackChunkName: "activation-email-page" */ "@/app/views/client-view/account-activation/activation-email-page/activation-email-page.vue"
	)
	

// Style Guide
const StyleGuideView = () =>
	import(/*webpackChunkName: "style-guide-view" */ "@/app/views/style-guide-view/style-guide-view.vue")

// Constants
import { BREEDER_ROUTES } from '@/app/constants/breeder-routes-constants';

// Error
const ErrorView = () => import(/*webpackChunkName: "error-view" */ "@/app/views/error-view/error-view.vue")
const QRCodeView = () => import(/*webpackChunkName: "qr-code-view" */ "@/app/views/qr-code-view/qr-code-view.vue")

Vue.use(Router)
const rootTitle = "Love My Dog Club"
const scrollBehavior = (to, from, savedPosition) => {
	// Scroll to Top
	document.getElementById("app").scrollTo(0, 0)
}

export default new Router({
	mode: "history",
	base: process.env.BASE_URL,
	scrollBehavior,
	routes: [
		// client
		{
			path: "/",
			component: ClientView,
			children: [
				{
					path: "/",
					component: ClientView,
					children: [
						{
							path: "/",
							name: "Landing Page",
							component: LandingPageContainer,
							meta: {
								title: `${rootTitle} - Home`,
								isAuthRequired: false,
								isGloballyAccessible: true,
							},
						},
						{
							path: "/health-check",
							name: "Health Check",
							component: HealthCheckContainer,
							meta: {
								title: `${rootTitle} - Health Check`,
								isAuthRequired: false,
								isGloballyAccessible: true,
							},
						},
						{
							path: "/privacy",
							name: "Privacy Policy",
							component: PrivacyPolicyPageContainer,
							meta: {
								title: `${rootTitle} - Privacy Policy`,
								isAuthRequired: false,
								isGloballyAccessible: true,
							},
						},
						{
							path: "/contact-us",
							name: "Contact Us",
							component: ContactUsPageContainer,
							meta: {
								title: `${rootTitle} - Contact Us`,
								isAuthRequired: false,
								isGloballyAccessible: true,
							},
						},
						{
							path: "/buy-puppy/success",
							name: "Dog Purchase Success",
							component: DogPurchaseSuccessContainer,
							meta: {
								title: `${rootTitle} - Dog Purchase Success`,
								isAuthRequired: false,
								isGloballyAccessible: true,
							},
						},
						{
							path: "/landing-transaction-status",
							name: "Dog Purchase Transaction",
							component: DogPurchaseTransactionContainer,
							meta: {
								title: `${rootTitle} - Dog Purchase Transaction`,
								isAuthRequired: false,
								isGloballyAccessible: true,
							},
						},
						{
							path: "/puppy-for-sale",
							name: "Puppies For Sale",
							component: PuppyForSalePageContainer,
							meta: {
								title: `${rootTitle} - Puppies For Sale`,
								isAuthRequired: false,
								isGloballyAccessible: true,
							},
						},
						{
							path: "/puppy-for-sale/pay-now",
							name: "Puppy Purchase Pay Now",
							component: PuppyPurchasePayNowContainer,
							meta: {
								title: `${rootTitle} - Puppy Purchase Pay Now`,
								isAuthRequired: false,
								isGloballyAccessible: true,
							},
						},
						{
							path: "/puppy-for-sale/details",
							name: "Puppies For Sale - Details",
							component: PuppyForSaleDetailsContainer,
							meta: {
								title: `${rootTitle} - Puppies For Sale Details`,
								isAuthRequired: false,
								isGloballyAccessible: true,
							},
						},
						{
							path: "/puppy-purchase-status",
							name: "Puppy Purchase Transaction",
							component: PuppyPurchaseContainer,
							meta: {
								title: `${rootTitle} - Puppy Purchase Transaction`,
								isAuthRequired: false,
								isGloballyAccessible: true,
							},
						},
						{
							path: "/puppy-packs",
							name: "Doggy Packs",
							component: DoggyPackPageListContainer,
							meta: {
								title: `${rootTitle} - Doggy Packs Page`,
								isAuthRequired: false,
								isGloballyAccessible: true,

						  },
            },
						{
							path: "/puppy-packs/details/:id",
							name: "Doggy Packs Details",
							component: DoggyPacksDetailsContainer,
							meta: {
							title: `${rootTitle} - Doggy Packs Details`,
							isAuthRequired: false,
							isGloballyAccessible: true,
							},
						},
						{
							path: "/activation-email",
							name: "Account Activation Email",
							component: ActivationEmailPage,
							meta: {
								title: `${rootTitle} - Account Activation Email`,
								isAuthRequired: false,
							},
						},
					],
				},
			],
		},
		// auth
		{
			path: "/",
			component: AuthContainer,
			children: [
				{
					path: "/login",
					name: "Auth Login",
					component: AuthLogin,
					meta: {
						title: `${rootTitle} - Login`,
						isAuthRequired: false,
					},
				},
				{
					path: "/create-account",
					name: "Auth Register - Create Account",
					component: AuthRegisterContainer,
					meta: {
						title: `${rootTitle} - Register`,
						isAuthRequired: false,
					},
				},
				{
					path: "/register",
					name: "Auth Register - Register",
					component: AuthRegisterContainer,
					meta: {
						title: `${rootTitle} - Register`,
						isAuthRequired: false,
					},
				},
				{
					path: "/forgot",
					name: "Auth Forgot Password",
					component: AuthForgotPass,
					meta: {
						title: `${rootTitle} - Forgot Password`,
						isAuthRequired: false,
					},
				},
				{
					path: "/reset-password",
					name: "Auth Reset Password",
					component: AuthSetPass,
					meta: {
						title: `${rootTitle} - Reset Password`,
						isAuthRequired: false,
					},
				},
				{
					path: "/set-password",
					name: "Auth Set Password",
					component: AuthSetPass,
					meta: {
						title: `${rootTitle} - Set Password`,
						isAuthRequired: false,
					},
				},
			],
		},
		// breeder registration (and user)
		{
			path: "/register/breeder",
			name: "Auth Register - Breeder Register",
			component: AuthBreederRegisterContainer,
			meta: {
				title: `${rootTitle} - Breeder Register`,
				isAuthRequired: false,
			},
		},
		// view breeder bio
		{
			path: "/breeder-bio",
			name: "Breeder Bio - Details",
			component: BreederBioDetailsContainer,
			meta: {
				title: `${rootTitle} - Breeder Bio`,
				isAuthRequired: false,
				isGloballyAccessible: true,
			},
		},
		{
			path: "/public-products",
			name: "Public Products",
			component: PublicProductsContainer,
			meta: {
				title: `${rootTitle} - Public Products`,
				isAuthRequired: false,
				isGloballyAccessible: true,
			},
		},
		{
			path: "/public-cart",
			name: "Public Cart",
			component: PublicCartContainer,
			meta: {
				title: `${rootTitle} - Public Cart`,
				isAuthRequired: false,
				isGloballyAccessible: true,
			},
		},

		// main
		{
			path: "/",
			component: MainView,
			meta: { title: `${rootTitle} - Dashboard` },
			redirect: "/dashboard",
			children: [
				// {
				//     path: '/general-info',
				//     name: 'General Information',
				//     component: GeneralInfoContainer,
				//     meta: {
				//         title: `${rootTitle} - General Information`,
				//         isAuthRequired: true
				//     },
				// },
				{
					path: "/dashboard",
					name: "Dashboard",
					component: GeneralInfoContainer,
					meta: {
						title: `${rootTitle} - Dashboard`,
						isAuthRequired: true,
					},
				},
				{
					path: "/walker-sitter",
					name: "WalkerSitter",
					component: WalkerSitterContainer,
					meta: {
						title: `${rootTitle} - Walker Sitter`,
						isAuthRequired: true,
					},
				},
				{
					path: "/exercise",
					name: "Exercise",
					component: PetExerciseContainer,
					meta: {
						title: `${rootTitle} - Exercise`,
						isAuthRequired: true,
					},
				},
				{
					path: "/purchases",
					component: PurchasesView,
					meta: {
						title: `${rootTitle} - Purchases`,
						isAuthRequired: true,
						customerOnly: true,
					},
					children: [
						{
							path: "/",
							name: "Purchases",
							redirect: "/purchases/orders",
							component: PurchasesContainer,
							meta: {
								title: `${rootTitle} - Purchases`,
								isAuthRequired: true,
								customerOnly: true,
							},
							children: [
								{
									path: "/purchases/orders",
									name: "ProductPurchaseListingContainer",
									component: ProductPurchaseListingContainer,
									meta: {
										title: `${rootTitle} - Product Orders`,
										isAuthRequired: true,
										customerOnly: true,
									},
								},
								{
									path: "/purchases/orders/:orderId/view",
									name: "ProductDetails",
									component: ProductPurchaseDetailsContainer,
									meta: {
										title: `${rootTitle} - Product Purchase Details`,
										isAuthRequired: true,
										customerOnly: true,
									},
								},
								{
									path: "/purchases/subscriptions",
									name: "SubscriptionListingContainer",
									component: SubscriptionListingContainer,
									meta: {
										title: `${rootTitle} - Product Subscriptions`,
										isAuthRequired: true,
										customerOnly: true,
									},
								},
								{
									path: "/purchases/subscriptions/:subscriptionId/view",
									name: "SubscriptionDetails",
									component: SubscriptionDetailsContainer,
									meta: {
										title: `${rootTitle} - Subscription Details`,
										isAuthRequired: true,
										customerOnly: true,
									},
								},
								{
									path: "/purchases/puppies",
									name: "PuppyPurchaseListingContainer",
									component: PuppyPurchaseListingContainer,
									meta: {
										title: `${rootTitle} - Puppy Purchase`,
										isAuthRequired: true,
										customerOnly: true,
									},
								},
								{
									path: "/purchases/puppies/:id/view",
									name: "PuppyPurchaseDetails",
									component: PuppyPurchaseDetails,
									meta: {
										title: `${rootTitle} - Puppy Purchase Details`,
										isAuthRequired: true,
									},
								},
							],
						},
					]
				},
				// {
				// 	path: "/dog-transactions",
				// 	name: "DogTransactions",
				// 	component: DogTransactionsContainer,
				// 	meta: {
				// 		title: `${rootTitle} - Dog Transactions`,
				// 		isAuthRequired: true,
				// 		customerOnly: true,
				// 	},
				// },
				{
					path: "/treatment",
					name: "Treatment",
					component: TreatmentContainer,
					meta: {
						title: `${rootTitle} - Treatment`,
						isAuthRequired: true,
					},
				},
				{
					path: "/social",
					name: "SocialClub",
					component: SocialClubContainer,
					meta: {
						title: `${rootTitle} - Social Club`,
						isAuthRequired: true,
					},
					children: [
						{
							path: "group",
							name: "SocialGroup",
							component: SocialClubContainer,
							meta: {
								title: `${rootTitle} - Social Club Group`,
								isAuthRequired: true,
							},
						},
					],
				},
				{
					path: "/post",
					name: "SocialClubPost",
					component: SocialPostContainer,
					meta: {
						title: `${rootTitle} - Social Club Post`,
						isAuthRequired: true,
					},
				},
				{
					path: "/products",
					component: ProductView,
					meta: {
						title: `${rootTitle} - Products`,
						isAuthRequired: true,
						customerOnly: true,
					},
					children: [
						{
							path: "/",
							name: "Products",
							component: ProductContainer,
							meta: {
								title: `${rootTitle} - Products`,
								isAuthRequired: true,
								customerOnly: true,
							},
						},
						{
							path: "/products/product-list",
							name: "Products Lists",
							component: ProductListContainer,
							meta: {
								title: `${rootTitle} - Products Lists`,
								isAuthRequired: true,
								customerOnly: true,
							},
						},
						{
							path: "/products/details",
							name: "Product Details",
							component: ProductDetailsContainer,
							meta: {
								title: `${rootTitle} - Product Details`,
								isAuthRequired: true,
								customerOnly: true,
							},
						},
						{
							path: "/products/cart",
							name: "Cart",
							component: ProductCartContainer,
							meta: {
								title: `${rootTitle} - Cart`,
								isAuthRequired: true,
								customerOnly: true,
							},
						},
						{
							path: "/products/checkout",
							name: "Checkout",
							component: ProductCheckoutContainer,
							meta: {
								title: `${rootTitle} - Checkout`,
								isAuthRequired: true,
								customerOnly: true,
							},
						},
						/*
						{
							path: "/purchases/product-transactions",
							name: "Transaction History",
							component: ProductTransactionHistoryContainer,
							meta: {
								title: `${rootTitle} - Transaction History`,
								isAuthRequired: true,
								customerOnly: true,
							},
						}, */
					],
				},
				{
					path: "/notifications",
					name: "Notifications",
					component: NotificationsContainer,
					meta: {
						title: `${rootTitle} - Notifications`,
						isAuthRequired: true,
					},
				},
				{
					path: "/settings",
					name: "Settings",
					component: SettingsContainer,
					meta: {
						title: `${rootTitle} - Settings`,
						isAuthRequired: true,
					},
				},
				{
					path: "/profile",
					name: "Profile",
					component: ProfileContainer,
					meta: {
						title: `${rootTitle} - Profile`,
						isAuthRequired: true,
					},
				},
				{
					path: "/change-password",
					name: "Change Password",
					component: ChangePassContainer,
					meta: {
						title: `${rootTitle} - Change Password`,
						isAuthRequired: true,
					},
				},
				{
					path: "/pet-profile",
					name: "Pet Profile",
					component: PetProfileContainer,
					meta: {
						title: `${rootTitle} - Pet Profile`,
						isAuthRequired: true,
					},
				},
				{
					path: "/app-sharing",
					name: "App Sharing",
					component: AppSharingContainer,
					meta: {
						title: `${rootTitle} - App Sharing`,
						isAuthRequired: true,
					},
				},
				{
					path: "/profile-walker-sitter",
					name: "Walker Sitter Profile",
					component: WalkerSitterProfileContainer,
					meta: {
						title: `${rootTitle} - Walker Sitter Profile`,
						isAuthRequired: true,
					},
				},
				{
					path: "/transaction-successful-page",
					name: "TransactionSuccess",
					component: TransactionSuccess,
					meta: {
						title: `${rootTitle} - Transaction Success`,
						isAuthRequired: true,
						customerOnly: true,
					},
				},
				{
					path: "/transaction-failed-page",
					name: "TransactionFailed",
					component: TransactionFailed,
					meta: {
						title: `${rootTitle} - Transaction Failed`,
						isAuthRequired: true,
						customerOnly: true,
					},
				},
				{
					path: "/transaction-status",
					name: "TransactionStatus - Transaction",
					component: TransactionStatus,
					meta: {
						title: `${rootTitle} - Transaction Status`,
						isAuthRequired: true,
						customerOnly: true,
					},
				},
				{
					path: "/pet-transaction-status",
					name: "TransactionStatus - Pet Transaction",
					component: TransactionStatus,
					meta: {
						title: `${rootTitle} - Transaction Status`,
						isAuthRequired: true,
						customerOnly: true,
					},
				},
				{
					path: BREEDER_ROUTES.PUPPY_SALES,
					component: SellYourDogView,
					meta: {
						title: `${rootTitle} - Puppy Sales`,
						isAuthRequired: true,
						customerOnly: true,
					},
					children: [
						{
							path: BREEDER_ROUTES.PUPPY_SALES,
							name: "Sell Your Dog",
							component: SellYourDogContainer,
							meta: {
								title: `${rootTitle} - Puppy Sales`,
								isAuthRequired: true,
								customerOnly: true,
							},
						},
						{
							path: BREEDER_ROUTES.SELL_YOUR_PUPPY_INFO,
							name: "Sell Your Dog Info",
							component: SellYourDogInfoContainer,
							meta: {
								title: `${rootTitle} - Sell Your Puppy`,
								isAuthRequired: true,
								customerOnly: true,
							},
						},
						{
							path: BREEDER_ROUTES.BREEDER_BIO,
							name: "Breeder Bio",
							component: BreederBioFormContainer,
							meta: {
								title: `${rootTitle} - Breeder Bio`,
								isAuthRequired: true,
								customerOnly: true,
							},
						},
					],
				},
				{
					path: BREEDER_ROUTES.DAM_SIRE_LIST,
					component: DamSireView,
					meta: {
						title: `${rootTitle} - Dam/Sire View`,
						isAuthRequired: true,
						customerOnly: true,
					},
					children: [
						{
							path: BREEDER_ROUTES.DAM_SIRE_LIST,
							name: "Dam/Sire List",
							component: DamSireListContainer,
							meta: {
								title: `${rootTitle} - Dam/Sire List`,
								isAuthRequired: true,
								customerOnly: true,
							},
						},
						{
							path: BREEDER_ROUTES.ADD_DAM_SIRE,
							name: "Add Dam/Sire",
							component: AddDamSireContainer,
							meta: {
								title: `${rootTitle} - Add Dam/Sire`,
								isAuthRequired: true,
								customerOnly: true,
							},
						},
						{
							path: `${BREEDER_ROUTES.EDIT_DAM_SIRE}`,
							name: "Edit Dam/Sire",
							component: EditDamSireContainer,
							meta: {
								title: `${rootTitle} - Edit Dam/Sire`,
								isAuthRequired: true,
								customerOnly: true,
							},
						},
						{
							path: `${BREEDER_ROUTES.DAM_SIRE_DOCUMENTS}`,
							name: "Dam/Sire Documents",
							component: DamSireDocumentsContainer,
							meta: {
								title: `${rootTitle} - Edit Dam/Sire`,
								isAuthRequired: true,
								customerOnly: true,
							},
						},
					],
				},
				{
					path: BREEDER_ROUTES.MATING_LIST,
					component: MatingView,
					meta: {
						title: `${rootTitle} - Mating List`,
						isAuthRequired: true,
						customerOnly: true,
					},
					children: [
						{
							path: BREEDER_ROUTES.MATING_LIST,
							name: "Mating",
							component: MatingDashboardContainer,
							meta: {
								title: `${rootTitle} - Mating List`,
								isAuthRequired: true,
								customerOnly: true,
							},
						},
						{
							path: BREEDER_ROUTES.ADD_MATING,
							name: "Add Mating",
							component: AddMatingOvulationGestationWhelpingContainer,
							meta: {
								title: `${rootTitle} - Add Mating`,
								isAuthRequired: true,
								customerOnly: true,
							},
						},
						{
							path: `${BREEDER_ROUTES.EDIT_MATING}`,
							name: "Edit Mating",
							component: EditMatingOvulationGestationWhelpingContainer,
							meta: {
								title: `${rootTitle} - Edit Mating`,
								isAuthRequired: true,
								customerOnly: true,
							},
						},
						{
							path: BREEDER_ROUTES.LITTER_LIST,
							name: "Litter List",
							component: LitterList,
							meta: {
								title: `${rootTitle} - Litter List`,
								isAuthRequired: true,
								customerOnly: true,
							},
						},	
						{
							path: BREEDER_ROUTES.EDIT_LITTER,
							name: "Edit Litter",
							component: EditLitterContainer,
							meta: {
								title: `${rootTitle} - Edit Litter`,
								isAuthRequired: true,
								customerOnly: true,
							},
						},
						{
							path: BREEDER_ROUTES.LITTER_REMINDER_AND_NOTES,
							name: "Reminder & Notes",
							component: LitterReminderAndNotesContainer,
							meta: {
								title: `${rootTitle} - Reminder & Notes`,
								isAuthRequired: true,
								customerOnly: true,
							},
						},
						{
							path: BREEDER_ROUTES.WAIT_LIST,
							name: "Waitlist",
							component: WaitlistTableContainer,
							meta: {
								title: `${rootTitle} - Waitlist`,
								isAuthRequired: true,
								customerOnly: true,
							},
						},
						{
							path: BREEDER_ROUTES.ALLOCATE_PUPPY,
							name: "Allocate Puppy",
							component: AllocatePuppyContainer,
							meta: {
								title: `${rootTitle} - Allocate Puppy`,
								isAuthRequired: true,
								customerOnly: true,
							},
						},
						{
							path: BREEDER_ROUTES.EDIT_ALLOCATED_PUPPY,
							name: "Edit Allocated Puppy",
							component: EditAllocatedPuppyContainer,
							meta: {
								title: `${rootTitle} - Edit Allocated Puppy`,
								isAuthRequired: true,
								customerOnly: true,
							},
						},
					],
				},
				// {
				// 	path: BREEDER_ROUTES.LITTER_MANAGEMENT,
				// 	component: PuppyManagementView,
				// 	meta: {
				// 		title: `${rootTitle} - Puppy Management`,
				// 		isAuthRequired: true,
				// 		customerOnly: true,
				// 	},
				// 	children: [
				// 		{
				// 			path: BREEDER_ROUTES.LITTER_MANAGEMENT,
				// 			name: "Puppy Management",
				// 			component: PuppyManagementList,
				// 			meta: {
				// 				title: `${rootTitle} - Puppy Management`,
				// 				isAuthRequired: true,
				// 				customerOnly: true,
				// 			},
				// 		},	
				// 	],
				// },
				{
					path: BREEDER_ROUTES.GESTATION_PERIOD,
					component: GestationPeriodContainer,
					meta: {
						title: `${rootTitle} - Gestation Period`,
						isAuthRequired: true,
						customerOnly: true,
					},
				}, 
				{
					path: BREEDER_ROUTES.ADD_LITTER,
					component: AddLitterContainer,
					meta: {
						title: `${rootTitle} - Add Litter`,
						isAuthRequired: true,
						customerOnly: true,
					},
				},
			],
		},
		// styleguide
		{
			path: "/styleguide",
			name: "Style Guide",
			component: StyleGuideView,
			meta: {
				title: `${rootTitle} - Style Guide`,
				isGloballyAccessible: true,
			},
		},
		// error
		{
			path: "*",
			name: "ErrorView",
			component: ErrorView,
			meta: {
				title: `${rootTitle} - Page Not Found`,
				isGloballyAccessible: true,
			},
		},
		// error
		{
			path: "/get-the-app",
			name: "QRCodeView",
			component: QRCodeView,
			meta: {
				title: `${rootTitle} - QR Code`,
				isGloballyAccessible: true,
			},
		},
	],
})
